import gql from 'graphql-tag';

const NAME = 'currentMove';
const FRAGMENT = `fragment ${NAME} on CurrentMove {
  env {
    name
  }
  id
  moveIqMoveId
  movingCompany {
    id
    name
    email
    phone
  }
  status
  moveType
  eligible
  user {
    firstName
    lastName
    email,
    phone
  },
  referrer
  liveUsers
  movesLeft
  showHomeInventorySteps
  viewedReservationRoute
}`;

export default {
  fragment: FRAGMENT,
  name: NAME,
  gql: gql`
    ${FRAGMENT}
  `,
};
